export const SHOPPING_LIST_VIEW_SIZE = 99;
export const LISTS_PER_LIST_FETCH_SIZE = 4;
